import { motion } from 'framer-motion';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-contrast-drop-line',
    title: 'Réparation de Vitrage',
    description: 'Remplacement rapide de vitres cassées ou fissurées. Intervention sous 24h pour tous types de vitrages simple ou double.',
    link: '/bordeaux'
  },
  {
    icon: 'ri-water-percent-line',
    title: 'Remplacement de Joints',
    description: 'Changement de joints d\'étanchéité pour améliorer l\'isolation et éviter les infiltrations d\'eau et d\'air.',
    link: '/bordeaux'
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Réglage de Mécanismes',
    description: 'Ajustement et réparation des systèmes d\'ouverture et de fermeture pour un fonctionnement optimal de vos fenêtres.',
    link: '/bordeaux'
  },
  {
    icon: 'ri-door-lock-line',
    title: 'Changement de Poignées',
    description: 'Remplacement de poignées et serrures pour fenêtres. Large choix de modèles adaptés à tous les styles.',
    link: '/bordeaux'
  },
  {
    icon: 'ri-temp-cold-line',
    title: 'Isolation Thermique',
    description: 'Amélioration de l\'isolation thermique et phonique de vos fenêtres pour réduire votre consommation énergétique.',
    link: '/bordeaux'
  },
  {
    icon: 'ri-window-line',
    title: 'Réparation Baies Vitrées',
    description: 'Réparation et entretien de baies vitrées coulissantes ou fixes. Remplacement de rails et mécanismes.',
    link: '/bordeaux'
  },
  {
    icon: 'ri-layout-grid-line',
    title: 'Réparation Volets Roulants',
    description: 'Dépannage et réparation de volets roulants manuels ou électriques. Remplacement de lames et moteurs.',
    link: '/bordeaux'
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Dépannage d\'Urgence',
    description: 'Service d\'urgence disponible 7j/7 pour tous vos problèmes de fenêtres, baies vitrées et volets roulants.',
    link: '/bordeaux'
  }
];

export function Services() {
  const servicesList = useMemo(() => services, []);

  return (
    <section id="services" className="py-24 bg-[#F5F3F0]">
      <div className="max-w-7xl mx-auto px-6">
        <motion.header
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-block bg-teal/10 text-teal px-6 py-2 rounded-full text-sm font-semibold mb-6">
            NOS SERVICES
          </div>
          <h2 className="text-5xl lg:text-6xl font-extrabold text-gray-900 mb-20 leading-tight">
            Expertise Complète<br />
            en Réparation
          </h2>
        </motion.header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {servicesList.map((service, index) => (
            <Link
              key={index}
              to={service.link}
              className="block"
            >
              <motion.article
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                whileHover={{ y: -8, boxShadow: '0 20px 40px rgba(0,0,0,0.12)' }}
                className="bg-white rounded-3xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer h-full"
              >
                <div className="w-16 h-16 flex items-center justify-center mb-8" aria-hidden="true">
                  <i className={`${service.icon} text-6xl text-teal`} style={{ strokeWidth: 2 }}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-6">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  {service.description}
                </p>
              </motion.article>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}